import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios"
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useEditExamPeriod = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const editExamPeriod = async (examPeriod: any) => {
        try {
            const response = await axios.put(`/api/examterms/${examPeriod.id}`, examPeriod);
            if (examPeriod.state === 1) {
                await axios.post(`/api/examterms/activate/${examPeriod.id}`);
            }
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.editExamPeriod"));
        }
    }

    return useMutation({ 
        mutationFn: editExamPeriod, 
        // onMutate: async (examPeriod: any) => {
        //     await queryClient.cancelQueries({queryKey: ["examPeriods", examPeriod.id]});
        //     const previousExamPeriod = queryClient.getQueryData(["examPeriods", examPeriod.id]);
        //     queryClient.setQueryData(["examPeriods", examPeriod.id], examPeriod);
        //     return { previousExamPeriod, examPeriod };
        // },
        // onError: (__, _, context) => {
        //     queryClient.setQueryData(["examPeriods", context?.examPeriod.id], context?.previousExamPeriod);
        // },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ["participants"] });
            queryClient.invalidateQueries({ queryKey: ["examPeriods", variables.id] });
            message.success(t("messages.success.editExamPeriod"));
        }
});
}